export default __webpack_public_path__ + "static/media/py.36f8e510.svg";